"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var _styles = require("@material-ui/core/styles");

var boxShadow = "0 6px 10px 0 rgba(0,0,0,0.14), 0 1px 18px 0 rgba(0,0,0,0.12), 0 3px 5px -1px rgba(0,0,0,0.2);";
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      backgroundColor: theme.palette.common.white,
      border: '2px solid',
      borderColor: "".concat(theme.palette.neutral.stainless),
      borderRadius: '1px',
      boxSizing: 'border-box',
      display: 'flex',
      transition: 'box-shadow .2s ease-out',
      cursor: 'pointer',
      '&:hover': {
        borderColor: theme.palette.sapphire[500],
        borderRadius: '4px',
        boxShadow: boxShadow
      }
    },
    input: {
      left: 0,
      opacity: 0,
      position: 'absolute'
    },
    disabled: {
      borderColor: (0, _colorManipulator.fade)(theme.palette.neutral.stainless, 0.5),
      boxShadow: 'none',
      cursor: 'not-allowed',
      '&:hover': {
        borderColor: (0, _colorManipulator.fade)(theme.palette.neutral.stainless, 0.5),
        boxShadow: 'none'
      }
    },
    selected: {
      border: '2px solid',
      borderColor: theme.palette.sapphire[500],
      boxShadow: boxShadow,
      borderRadius: '4px'
    },
    focusVisible: {
      border: "2px dashed",
      borderColor: theme.palette.sapphire[500],
      borderRadius: '4px',
      boxShadow: boxShadow,
      outline: "none"
    }
  };
}, {
  name: 'pds-selector'
});
var _default = useStyles;
exports.default = _default;
